import React from "react";
import { mqMin } from "../../styles/theme";

export default ({ photos, columns = 3 }) => (
  <div
    css={{
      display: "flex",
      overflowY: "scroll",
      "-webkit-overflow-scrolling": "touch",
      alignItems: "center",
      [mqMin(750)]: {
        flexWrap: "wrap",
        overflowY: "hidden",
        justifyContent: "center"
      }
    }}
  >
    {photos.map((p, i) => (
      <div
        key={i}
        css={{
          padding: "0.5rem",
          alignItems: "center",
          flexBasis: `${85}%`,
          flex: "0 0 auto",
          width: `${85}%`,
          [mqMin(750)]: {
            padding: "1rem",
            flexBasis: `${100 / columns}%`,
            flex: "0 0 auto",
            width: `${100 / columns}%`
          }
        }}
      >
        <a
          href={p.full_resolution.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={p.thumbnail.url}
            alt=""
            className="lazyload"
            css={{ width: "100%", height: "auto" }}
          />
        </a>
      </div>
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PhotoGrid/index.js